module.exports = __webpack_public_path__ + "img/link-solid.6af56728.svg";